import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AxisRtspPlayerService } from '../../services/axis-rtsp-player.service';
import { Recordings } from '../../interfaces/recordings.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'avs-axis-rtsp-player',
  standalone: false,
  templateUrl: './axis-rtsp-player-service.component.html',
  styleUrl: './axis-rtsp-player-service.component.css'
})
export class AxisRtspPlayerComponent {
  @ViewChild('vid', { static: true }) vid!: ElementRef<HTMLVideoElement>;

  // Passe das auf deine Umgebung an:
  wsUrl = 'ws://localhost:4000/camera/rtsp-over-websocket?rs=<GUID>&token=<JWT>';
  rtspBase = 'rtsp://axis/axis-media/media.amp'; // was ist das bei uns?
  codec = 'h264';
  recordingId = ''; // leer = live
  startIso = '';
  stopIso = '';
  environment = environment;
  /*   @Input() rtspUri: string = '';  */// alternativ volle RTSP-URL
  @Input() rs: string = ''; // alternativ volle WebSocket-URL
  @Input() token: string = ''; // alternativ volle WebSocket-URL
  @Input() selectedRecording: Recordings | undefined = undefined;

  constructor(private player: AxisRtspPlayerService) {
    if (this.selectedRecording) {
      this.recordingId = this.selectedRecording.id;
      this.startIso = this.selectedRecording.startTime;
      this.stopIso = this.selectedRecording.endTime ?? '';
    }
  }

  buildRtspUri(): string {
    if (this.selectedRecording) {
      this.recordingId = this.selectedRecording.id;
      this.startIso = this.selectedRecording.startTime;
      this.stopIso = this.selectedRecording.endTime ?? '';
    }
    const params: string[] = [];
    if (this.codec) params.push('videocodec=' + encodeURIComponent(this.codec));
    if (this.recordingId) params.push('recordingid=' + encodeURIComponent(this.recordingId));
    return params.length ? `${this.rtspBase}?${params.join('&')}` : this.rtspBase;
  }

  start() {
    const rtspUri = this.buildRtspUri()
    let baseApi = environment.apiAddress;
    this.wsUrl = `${baseApi.replace('http', 'ws')}Camera/rtspws-recording?rs=${this.rs}&token=${this.token}`;
    // Start the player

    this.player.start(this.vid.nativeElement, this.wsUrl, rtspUri);
  }

  startWithRange() {
    // für Aufnahmen empfehlenswert: PLAY mit Range-Header
    this.start();
    const range = this.recordingId
      ? this.buildClockRange(this.startIso, this.stopIso) || 'npt=0-'
      : 'npt=0-';
    this.player.playWithRange(range);
  }

  stop() {
    this.player.stop();
  }

  private buildClockRange(startIso?: string, stopIso?: string) {
    const s = (startIso || '').trim();
    const e = (stopIso || '').trim();
    if (!s) return '';
    const start = this.isoToAxisClock(s);
    const stop = e ? this.isoToAxisClock(e) : '';
    return `clock=${start}${stop ? '-' + stop : '-'}`;
  }

  private isoToAxisClock(iso: string) {
    // "2025-09-11T07:59:23Z" -> "20250911T075923Z"
    return iso.replace(/[-:]/g, '').replace(/(\.\d+)?Z?$/, 'Z');
  }
}